import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateEventRequest as CreateEventFormData, EventViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventNormalizers from '../normalizers/eventNormalizers';

import { toFormData, appendAsJSONFile } from 'helpers/requestHelper';

export class CreateEventRequest extends BaseApiPostRequest<
  EventViewModel,
  EntityNormalizers.NormalizedSingleEntity<EventNormalizers.NormalizedEvents>
> {
  constructor(createEventFormData: CreateEventFormData, component: React.Component, dispatch: Dispatch) {
    super(createEventFormData, component, dispatch);
    this.path = `/events`;
    this.normalizeMethod = EventNormalizers.normalizeEvent;
  }

  protected generateRequest() {
    const request = super.generateRequest();
    const { clipConfiguration, ...requestBody } = this.body;

    request.body = toFormData(requestBody);
    appendAsJSONFile(request.body, 'clipConfiguration', clipConfiguration);

    return request;
  }

  protected generateHeaders() {
    const headers = super.generateHeaders();
    headers.delete('Content-type');

    return headers;
  }
}
